import { useFeatureFlags } from '../../contexts/FeatureFlagsContext.jsx';
import { getFeatureUnavailableMessage } from '../../utils/features.js';

const FeatureAccessGuard = ({ featureCode, featureCodes, children }) => {
  const { loading, error, hasFeature } = useFeatureFlags();
  const requiredCodes = featureCodes || (featureCode ? [featureCode] : []);

  if (requiredCodes.length === 0) {
    return children;
  }

  if (loading) {
    return (
      <div className="rounded-2xl border border-neutral-200 bg-white p-6 text-sm text-neutral-500">
        Se verifică accesul la modul...
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-800">
        {error}
      </div>
    );
  }

  const missingFeature = requiredCodes.find((code) => !hasFeature(code));
  if (missingFeature) {
    return (
      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-800">
        {getFeatureUnavailableMessage(missingFeature)}
      </div>
    );
  }

  return children;
};

export default FeatureAccessGuard;
